import { useFormikContext } from 'formik';
import useDebouncedEffect from 'hooks/useDebouncedEffect';

interface ISaveForm {
  form: string;
  values?: object;
}

const setItem = ({ form, values }: ISaveForm) => localStorage.setItem(form, JSON.stringify(values));

export const SaveFormStorage = ({ form }: ISaveForm) => {
  const { values } = useFormikContext<object>();

  useDebouncedEffect(
    () => {
      setItem({ form, values });
    },
    600,
    [values]
  );

  return <></>;
};
